export enum PlanFeatureEnum {
  FEATURE_1 = "feature-1",
  FEATURE_2 = "feature-2",
  FEATURE_3 = "feature-3",
  FEATURE_4 = "feature-4",
  FEATURE_5 = "feature-5",
  FEATURE_6 = "feature-6",
  FEATURE_7 = "feature-7",
  FEATURE_8 = "feature-8",
  FEATURE_9 = "feature-9",
  FEATURE_10 = "feature-10",
  FEATURE_11 = "feature-11",
  FEATURE_12 = "feature-12",
  FEATURE_13 = "feature-13",
  FEATURE_14 = "feature-14",
  FEATURE_15 = "feature-15",
  FEATURE_16 = "feature-16",
  FEATURE_17 = "feature-17",
  FEATURE_18 = "feature-18",
  FEATURE_19 = "feature-19",
  FEATURE_20 = "feature-20",
  FEATURE_21 = "feature-21",
  FEATURE_22 = "feature-22",
  FEATURE_23 = "feature-23",
  FEATURE_24 = "feature-24",
}
